import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { DropdownComponent, TextFieldComponent } from '../../controls';
import { DropdownOption } from './../../controls/dropdown/dropdown.model';

@Component({
  selector: 'ui-table-header',
  standalone: true,
  imports: [TextFieldComponent, DropdownComponent, ReactiveFormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './table-header.component.html',
  styleUrl: './table-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderComponent<T> {
  public readonly placeholder = input.required<string>();
  public readonly dropdownOptions = input.required<DropdownOption<T>[]>();
}
